import * as yup from 'yup';

export const addMetricsToGroupsSchema = yup.object().shape({
  groups: yup.object().shape({}),
});
